export const isAuth = () => localStorage.setItem('accessToken', response.data.access)
